"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ReceiveSlotEvents = exports.ReceiveSlot = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));
var _weakMap = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/weak-map"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _classPrivateFieldGet2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classPrivateFieldGet"));
var _classPrivateFieldSet2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classPrivateFieldSet"));
var _internalMediaCore = require("@webex/internal-media-core");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _eventsScope = _interopRequireDefault(require("../common/events/events-scope"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } } /* eslint-disable valid-jsdoc */
var ReceiveSlotEvents = exports.ReceiveSlotEvents = {
  SourceUpdate: 'sourceUpdate',
  MaxFsUpdate: 'maxFsUpdate'
};
var receiveSlotCounter = 0;
var _memberId = /*#__PURE__*/new _weakMap.default();
var _csi = /*#__PURE__*/new _weakMap.default();
var _sourceState = /*#__PURE__*/new _weakMap.default();
/**
 * Class representing a receive slot. A single receive slot is able to receive a single track
 * for example some participant's main video or audio
 */
var ReceiveSlot = exports.ReceiveSlot = /*#__PURE__*/function (_EventsScope) {
  (0, _inherits2.default)(ReceiveSlot, _EventsScope);
  var _super = _createSuper(ReceiveSlot);
  /**
   * constructor - don't use it directly, you should always use meeting.receiveSlotManager.allocateSlot()
   * to create any receive slots
   *
   * @param {MediaType} mediaType
   * @param {ReceiveSlot} mcReceiveSlot
   * @param {FindMemberIdCallback} findMemberIdCallback callback for finding memberId for given CSI
   */
  function ReceiveSlot(mediaType, mcReceiveSlot, findMemberIdCallback) {
    var _this;
    (0, _classCallCheck2.default)(this, ReceiveSlot);
    _this = _super.call(this);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mcReceiveSlot", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "findMemberIdCallback", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "id", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mediaType", void 0);
    _classPrivateFieldInitSpec((0, _assertThisInitialized2.default)(_this), _memberId, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec((0, _assertThisInitialized2.default)(_this), _csi, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec((0, _assertThisInitialized2.default)(_this), _sourceState, {
      writable: true,
      value: void 0
    });
    receiveSlotCounter += 1;
    _this.findMemberIdCallback = findMemberIdCallback;
    _this.mediaType = mediaType;
    _this.mcReceiveSlot = mcReceiveSlot;
    (0, _classPrivateFieldSet2.default)((0, _assertThisInitialized2.default)(_this), _sourceState, 'no source');
    _this.id = "r".concat(receiveSlotCounter);
    _this.setupEventListeners();
    return _this;
  }

  /**
   * Getter for memberId
   */
  (0, _createClass2.default)(ReceiveSlot, [{
    key: "memberId",
    get: function get() {
      return (0, _classPrivateFieldGet2.default)(this, _memberId);
    }

    /**
     * Getter for csi
     */
  }, {
    key: "csi",
    get: function get() {
      return (0, _classPrivateFieldGet2.default)(this, _csi);
    }

    /**
     * Set the max frame size for this slot
     * @param newFs frame size
     */
  }, {
    key: "setMaxFs",
    value: function setMaxFs(newFs) {
      // emit event for media request manager to listen to

      this.emit({
        file: 'meeting/receiveSlot',
        function: 'findMemberId'
      }, ReceiveSlotEvents.MaxFsUpdate, {
        maxFs: newFs
      });
    }

    /**
     * Getter for sourceState
     */
  }, {
    key: "sourceState",
    get: function get() {
      return (0, _classPrivateFieldGet2.default)(this, _sourceState);
    }

    /**
     * registers event handlers with the underlying ReceiveSlot
     */
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this2 = this;
      var scope = {
        file: 'meeting/receiveSlot',
        function: 'setupEventListeners'
      };
      this.mcReceiveSlot.on(_internalMediaCore.ReceiveSlotEvents.SourceUpdate, function (state, csi) {
        _loggerProxy.default.logger.log("ReceiveSlot#setupEventListeners --> got source update on receive slot ".concat(_this2.id, ", mediaType=").concat(_this2.mediaType, ", csi=").concat(csi, ", state=").concat(state));
        (0, _classPrivateFieldSet2.default)(_this2, _memberId, csi ? _this2.findMemberIdCallback(csi) : undefined);
        (0, _classPrivateFieldSet2.default)(_this2, _csi, csi);
        (0, _classPrivateFieldSet2.default)(_this2, _sourceState, state);
        _this2.emit(scope, ReceiveSlotEvents.SourceUpdate, {
          state: (0, _classPrivateFieldGet2.default)(_this2, _sourceState),
          csi: (0, _classPrivateFieldGet2.default)(_this2, _csi),
          memberId: (0, _classPrivateFieldGet2.default)(_this2, _memberId)
        });
      });
    }

    /** Tries to find the member id for this receive slot if it hasn't got one */
  }, {
    key: "findMemberId",
    value: function findMemberId() {
      if ((0, _classPrivateFieldGet2.default)(this, _memberId) === undefined && (0, _classPrivateFieldGet2.default)(this, _csi)) {
        (0, _classPrivateFieldSet2.default)(this, _memberId, this.findMemberIdCallback((0, _classPrivateFieldGet2.default)(this, _csi)));
        if ((0, _classPrivateFieldGet2.default)(this, _memberId)) {
          // if we found the memberId, simulate source update so that the client app knows that something's changed
          this.emit({
            file: 'meeting/receiveSlot',
            function: 'findMemberId'
          }, ReceiveSlotEvents.SourceUpdate, {
            state: (0, _classPrivateFieldGet2.default)(this, _sourceState),
            csi: (0, _classPrivateFieldGet2.default)(this, _csi),
            memberId: (0, _classPrivateFieldGet2.default)(this, _memberId)
          });
        }
      }
    }

    /**
     * @returns {string} a log message used to identify the receive slot
     */
  }, {
    key: "logString",
    get: function get() {
      return "ReceiveSlot - ".concat(this.id, ": ").concat((0, _stringify.default)(this.mcReceiveSlot.id));
    }

    /**
     * The MediaStream object associated with this slot.
     *
     * @returns {MediaStream} The MediaStreamTrack.
     */
  }, {
    key: "stream",
    get: function get() {
      return this.mcReceiveSlot.stream;
    }

    /**
     * The underlying WCME receive slot
     */
  }, {
    key: "wcmeReceiveSlot",
    get: function get() {
      return this.mcReceiveSlot;
    }
  }]);
  return ReceiveSlot;
}(_eventsScope.default);
//# sourceMappingURL=receiveSlot.js.map
